const mutations = {
  SET_SELECTED_NOTE(state, selectedNote) {
    state.selectedNote = selectedNote;
  },

  SET_SELECTED_DATA_ON_SPED(state, selectedDataOnSped) {
    state.selectedDataOnSped = selectedDataOnSped;
  },

  SET_ALL_SELECTED_DATA_ON_NFE(state, allSelectedDataOnNfe) {
    state.allSelectedDataOnNfe = allSelectedDataOnNfe;
  },
  SET_SHOW_ACCOUNTS_GRID(state, showAccountsGrid) {
    state.showAccountsGrid = showAccountsGrid;
  },
  SET_DID_CHANGE_CTA(state, didChangeCta) {
    state.didChangeCta = didChangeCta;
  },
  SET_SELECTED_SPED(state, selectedSped) {
    state.selectedSped = selectedSped;
  },
  SET_CFOP_LIST(state, cfopList) {
    state.cfopList = cfopList;
  },
  SET_FAVORITE_ACCOUNTS(state, favoriteAccounts) {
    state.favoriteAccounts = favoriteAccounts;
  },
  SET_IS_MOV_ICMS(state, isMovIcms) {
    state.isMovIcms = isMovIcms;
  },
  SET_LAST_NOTE_OPEN(state, lastNoteOpen) {
    state.lastNoteOpen = lastNoteOpen;
  },
  SET_KEYS_SELECTED_TO_SUM(state, keysSelectedToSum) {
    state.keysSelectedToSum = keysSelectedToSum;
  },
  SET_SELECTED_KEYS_TO_SHOW_SPED(state, selectedKeysToShowSped) {
    state.selectedKeysToShowSped = selectedKeysToShowSped;
  },
  SET_SELECTED_KEYS_TO_SHOW_NFE(state, selectedKeysToShowNfe) {
    state.selectedKeysToShowNfe = selectedKeysToShowNfe;
  },
  SET_SELECTED_NOTE_VL_ICMS_CLIENT(state, selectedNoteVlIcmsClient) {
    state.selectedNoteVlIcmsClient = selectedNoteVlIcmsClient;
  },
  SET_VIEW_ONLY_NODE(state, viewOnlyMode) {
    state.viewOnlyMode = viewOnlyMode;
  },
};

export default mutations;
